export const GET_HEADERS = 'headers/allHeaders/get';
export const GET_HEADERS_BY_SLUG = 'headers/headerBySlug/get';